<template>
  <div class="scroller">
    <div class="resource">
      <header class="resource__header">
        <h2 class="resource__heading" v-if="action === 'create'">New category</h2>
        <h2 class="resource__heading" v-else>Edit category</h2>

        <div class="languages">
          <img v-for="(globalLanguage, index) in languages" :key="index" :src="`/static/flags/${globalLanguage.iso}.png`" class="languages__image" @click="changeOrAddLanguage(globalLanguage.iso)" :class="{'languages__image--active': language == globalLanguage.iso }">
        </div>
      </header>

      <form class="form" @submit.prevent="onSubmit">
          <div class="grid">
            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="title">Title:</label>
                <span class="form__error" v-if="errors.has('title')">{{ errors.first('title') }}</span>
                <input
                  type="text" id="title" name="title"
                  class="form__input" :class="{ 'form__input--error': errors.has('title') }"
                  v-validate="{ required: true }"
                  v-model="category.languages[language].title"
                  @blur="category.languages[language].url.length === 0 && category.languages[language].title.length > 0 ? generateSeoTitle() : null"
                />
              </div>

              <div class="form__group--url">
                <span class="form__error" v-if="errors.has('url')">{{ errors.first('url') }}</span>
                <input
                  type="text" id="url" name="url"
                  class="form__input" :class="{ 'form__input--error': errors.has('url') }"
                  v-validate="{ required: true }"
                  v-model="category.languages[language].url"
                  @input="slugifyOnTyping($event.target.value)"
                />
                <button type="button" class="btn btn--primary btn--url" @click="generateSeoTitle">Regenerate</button>
              </div>

              <div class="formToggle">
                <input class="formToggle__checkbox" type="checkbox" name="is_featured" id="is_featured" v-model="category.additionals.is_featured">
                <label class="formToggle__label formToggle__label--large" for="is_featured"><span>ON/OFF</span> Category is featured</label>
              </div>
            </div>
            <div class="grid__column--six">
              <div class="form__group">
                <label class="form__label" for="parent_id">Parent category:</label>
                <span class="form__error" v-if="errors.has('parent_id')">{{ errors.first('parent_id') }}</span>
                <select
                  id="parent_id" name="parent_id"
                  v-model="category.parent_id"
                  class="form__input" :class="{ 'form__input--error': errors.has('url') }"
                >
                  <option :value="null">--</option>
                  <option v-for="_category in allCategories" :key="_category.id" :value="_category.id" v-if="isNotSubCategoryOrSameCategory(category, _category)">
                    {{ _category.languages[language].title }}
                  </option>
                </select>
              </div>

              <div class="form__group">
                <UploadImage :image.sync="category.languages[language].featured_image"/>
              </div>
            </div>
          </div>
          <div class="flex__row">
            <div class="flex__oneFull">
              <button type="submit" class="btn btn--primary mt1" v-if="action === 'create'">PUBLISH</button>
              <button type="submit" class="btn btn--primary mt1" v-else>UPDATE</button>
            </div>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import Category from '@/model/Category'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import * as types from '@/store/types.js'
import {slugify, slugifyString, submitResource} from '@/helpers/handleForm.js'
import UploadImage from '@/components/Utils/UploadImage'

export default {
  components: {
    codemirror, UploadImage
  },
  computed: {
    allCategories () {
      return this.$store.getters[types.ALL_CATEGORIES]
    },
    languageGlobal () {
      return this.$store.getters[types.ACTIVE_LANGUAGE]
    },
    languages () {
      return this.$store.getters[types.LANGUAGES]
    }
  },
  props: {
    action: {
      type: String,
      default: 'edit'
    },
    category: {
      type: Object,
      default () {
        return {
          parent_id: null,
          languages: {},
          additionals: {
            is_featured: false
          }
        }
      }
    }
  },
  data () {
    return {
      language: ''
    }
  },
  methods: {
    onSubmit () {
      if (Object.keys(this.category.languages).length !== this.languages.length) {
        this.$snotify.error('Please enter all languages before submitting.')
        return
      }
      submitResource(this.$validator, Category, this.category, this.action)
    },
    generateSeoTitle () {
      slugify(this.category, types.UPDATE_CATEGORY_URL, this.action, this.language)
    },
    slugifyOnTyping (value) {
      this.category.languages[this.language].url = slugifyString(value)
    },
    isNotSubCategoryOrSameCategory (activeCategory, category) {
      let returnType = true

      // If category is same as opened  category dont display it
      if (activeCategory.id === category.id) {
        returnType = false
      }

      // If category is child of opened category
      if (this.categoryIsChildOfOpenedCategory(activeCategory, category)) {
        returnType = false
      }

      return returnType
    },
    categoryIsChildOfOpenedCategory (activeCategory, category) {
      if (activeCategory.id === category.parent_id) {
        return true
      }
    },
    changeOrAddLanguage (language) {
      if (!this.category.languages[language]) {
        this.$set(this.category.languages, language, this.languageDefaults(language))
      }
      this.language = language
    },
    languageDefaults (language) {
      return {
        title: '',
        url: '',
        additionals: {},
        language: language
      }
    }
  },
  created () {
    this.language = this.languageGlobal

    if (this.action === 'create') {
      this.$set(this.category.languages, this.language, this.languageDefaults(this.language))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Category/CategoryForm.vue